import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6237cacc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-global analytics-page" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "toolbar" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { value: "" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { value: "" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { value: "" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  role: "alert",
  class: "error"
}
const _hoisted_12 = {
  key: 1,
  role: "status"
}
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["value", "max", "aria-label"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["onSubmit"]
const _hoisted_18 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "chosen" }
const _hoisted_22 = ["disabled", "aria-label", "onClick"]
const _hoisted_23 = ["disabled", "aria-label", "onClick"]
const _hoisted_24 = { class: "choices" }
const _hoisted_25 = ["value", "disabled"]
const _hoisted_26 = { class: "toolbar" }

import { computed, ref, reactive, watch, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { Button } from '@/components/common';
import Modal from '@/components/common/Modal.vue';
import HrDataService from '@/services/hr/HrDataService';
import { AuthGetters } from '@/store/modules/auth';
import { accountKey } from '@/utils/accountSession';
import { t, getLocale } from '@/i18n';
interface Metric {key:string; label:string; value:number; total:number|null}
interface Report {totalEmployees:number; metrics:Record<string,Metric>}
interface Layout {columns:number; widgets:string[]}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/* eslint-disable @typescript-eslint/no-unused-vars */
const store=useStore();
const permissions=computed<string[]>(()=>store.getters[AuthGetters.GET_USER_IDENTITY]?.permissions || []);
const canConfigure=computed(()=>permissions.value.includes('HR_SETTINGS_MANAGE'));
const statuses=['ACTIVE','DISMISSED','ARCHIVED','SERVICE'];
const statusKeys:Record<string,string>={ACTIVE:'hr.statusActive',DISMISSED:'hr.statusDismissed',ARCHIVED:'hr.statusArchived',SERVICE:'hr.statusService'};
function statusLabel(value:string){return t(statusKeys[value] || value);}
const filters=reactive({query:'',employeeTypeId:'',jobId:'',status:''});
const jobs=ref<{id:string;name:string}[]>([]),employeeTypes=ref<{id:string;name:string}[]>([]);
const report=ref<Report|null>(null),layout=ref<Layout>({columns:3,widgets:[]});
const draft=reactive<Layout>({columns:3,widgets:[]});
const loading=ref(false),ready=ref(false),error=ref(''),editing=ref(false),saving=ref(false),saveError=ref('');
let generation=0,requestSequence=0,timer:ReturnType<typeof setTimeout>|undefined;
const visibleMetrics=computed(()=>layout.value.widgets.map(key=>report.value?.metrics[key]).filter((metric):metric is Metric=>Boolean(metric)));
function metricLabel(metric:Metric){
  if(metric.key.startsWith('status.'))return statusLabel(metric.key.slice(7));
  if(metric.key.startsWith('category.'))return metric.label;
  const key='hr.analyticsMetric.'+metric.key;
  const translated=t(key); return translated===key?metric.label:translated;
}
function cancel(){if(timer!==undefined)clearTimeout(timer);timer=undefined;}
async function refresh(){
  cancel();if(!ready.value || !permissions.value.includes('HR_VIEW'))return;
  const request=++requestSequence,session=generation;loading.value=true;error.value='';
  try{const response=await HrDataService.getAnalytics({...filters});if(session===generation && request===requestSequence)report.value=response.data.data;}
  catch{if(session===generation && request===requestSequence){report.value=null;error.value=t('hr.loadError');}}
  finally{if(session===generation && request===requestSequence)loading.value=false;}
}
async function initialize(){
  cancel();const session=++generation;++requestSequence;ready.value=false;report.value=null;editing.value=false;saving.value=false;error.value='';saveError.value='';jobs.value=[];employeeTypes.value=[];layout.value={columns:3,widgets:[]};
  if(!permissions.value.includes('HR_VIEW'))return;
  loading.value=true;
  try{const [settings,reference,types]=await Promise.all([HrDataService.getAnalyticsLayout(),HrDataService.getReferenceData(),HrDataService.getEmployeeTypes()]);
    if(session!==generation)return;layout.value=settings.data.data;jobs.value=reference.data.data.jobs;employeeTypes.value=types.data.data;ready.value=true;await refresh();
  }catch{if(session===generation){error.value=t('hr.loadError');loading.value=false;}}
}
function configure(){draft.columns=layout.value.columns;draft.widgets=layout.value.widgets.filter(key=>Boolean(report.value?.metrics[key]));saveError.value='';editing.value=true;}
function move(index:number,direction:number){const next=index+direction;if(next<0 || next>=draft.widgets.length)return;const keys=[...draft.widgets];[keys[index],keys[next]]=[keys[next],keys[index]];draft.widgets=keys;}
async function save(){
  if(saving.value || !canConfigure.value)return;const session=generation;saving.value=true;saveError.value='';
  try{const response=await HrDataService.saveAnalyticsLayout({columns:draft.columns,widgets:[...draft.widgets]});if(session!==generation)return;layout.value=response.data.data;editing.value=false;}
  catch{if(session===generation)saveError.value=t('hr.analyticsSaveError');}
  finally{if(session===generation)saving.value=false;}
}
watch(filters,()=>{cancel();requestSequence++;report.value=null;if(ready.value)timer=setTimeout(refresh,300);},{flush:'sync'});
watch(()=>accountKey(store.getters[AuthGetters.GET_USER_IDENTITY]),()=>{ready.value=false;Object.assign(filters,{query:'',employeeTypeId:'',jobId:'',status:''});void initialize();},{flush:'sync'});
watch(canConfigure,allowed=>{if(!allowed)editing.value=false;});
watch(()=>permissions.value.includes('HR_VIEW'),allowed=>{if(!allowed){generation++;requestSequence++;cancel();report.value=null;ready.value=false;editing.value=false;}},{flush:'sync'});
onMounted(initialize);onBeforeUnmount(()=>{generation++;requestSequence++;cancel();});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)('hr.analytics')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('hr.analyticsHint')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: {name:'HrEmployeeList'} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('hr.employees')), 1)
          ]),
          _: 1
        }),
        (_unref(canConfigure) && report.value && !loading.value)
          ? (_openBlock(), _createBlock(_unref(Button), {
              key: 0,
              variant: "default",
              onClick: configure
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('hr.analyticsConfigure')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("form", {
      class: "filters",
      onSubmit: _withModifiers(refresh, ["prevent"])
    }, [
      _createElementVNode("label", null, [
        _createTextVNode(_toDisplayString(_unref(t)('hr.searchEmployee')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).query) = $event)),
          class: "input-form",
          type: "search"
        }, null, 512), [
          [
            _vModelText,
            _unref(filters).query,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("label", null, [
        _createTextVNode(_toDisplayString(_unref(t)('hr.employmentType')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters).employeeTypeId) = $event)),
          class: "input-form"
        }, [
          _createElementVNode("option", _hoisted_5, _toDisplayString(_unref(t)('hr.all')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employeeTypes.value, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.id,
              value: item.id
            }, _toDisplayString(item.name), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, _unref(filters).employeeTypeId]
        ])
      ]),
      _createElementVNode("label", null, [
        _createTextVNode(_toDisplayString(_unref(t)('common.job')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).jobId) = $event)),
          class: "input-form"
        }, [
          _createElementVNode("option", _hoisted_7, _toDisplayString(_unref(t)('hr.all')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobs.value, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.id,
              value: item.id
            }, _toDisplayString(item.name), 9, _hoisted_8))
          }), 128))
        ], 512), [
          [_vModelSelect, _unref(filters).jobId]
        ])
      ]),
      _createElementVNode("label", null, [
        _createTextVNode(_toDisplayString(_unref(t)('common.status')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filters).status) = $event)),
          class: "input-form"
        }, [
          _createElementVNode("option", _hoisted_9, _toDisplayString(_unref(t)('hr.all')), 1),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statuses, (status) => {
            return _createElementVNode("option", {
              key: status,
              value: status
            }, _toDisplayString(statusLabel(status)), 9, _hoisted_10)
          }), 64))
        ], 512), [
          [_vModelSelect, _unref(filters).status]
        ])
      ])
    ], 40, _hoisted_4),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(t)('hr.loading')), 1))
      : (report.value)
        ? (_openBlock(), _createElementBlock("section", {
            key: 2,
            class: "metrics",
            style: _normalizeStyle({'--columns':layout.value.columns}),
            "aria-label": _unref(t)('hr.analytics')
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleMetrics), (metric) => {
              return (_openBlock(), _createElementBlock("article", {
                key: metric.key,
                class: _normalizeClass(["metric", metric.key.replace('.', '-')])
              }, [
                _createElementVNode("h2", null, _toDisplayString(metricLabel(metric)), 1),
                _createElementVNode("strong", null, _toDisplayString(metric.value), 1),
                (metric.total !== null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, " / " + _toDisplayString(metric.total), 1))
                  : _createCommentVNode("", true),
                (metric.total && metric.total > 0)
                  ? (_openBlock(), _createElementBlock("progress", {
                      key: 1,
                      value: metric.value,
                      max: metric.total,
                      "aria-label": metricLabel(metric)
                    }, null, 8, _hoisted_15))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128)),
            (!_unref(visibleMetrics).length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_unref(t)('hr.analyticsEmpty')), 1))
              : _createCommentVNode("", true)
          ], 12, _hoisted_13))
        : _createCommentVNode("", true),
    _createVNode(Modal, {
      show: editing.value,
      title: _unref(t)('hr.analyticsConfigure'),
      onClose: _cache[7] || (_cache[7] = ($event: any) => (!saving.value && (editing.value = false)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          class: "configuration",
          onSubmit: _withModifiers(save, ["prevent"])
        }, [
          (saveError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(saveError.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("label", null, [
            _createTextVNode(_toDisplayString(_unref(t)('hr.analyticsColumns')), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(draft).columns) = $event)),
              class: "input-form",
              disabled: saving.value
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                return _createElementVNode("option", {
                  key: n,
                  value: n
                }, _toDisplayString(n), 9, _hoisted_20)
              }), 64))
            ], 8, _hoisted_19), [
              [
                _vModelSelect,
                _unref(draft).columns,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("ol", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(draft).widgets, (key, index) => {
              return (_openBlock(), _createElementBlock("li", { key: key }, [
                _createElementVNode("span", null, _toDisplayString(metricLabel(report.value?.metrics[key] || {key,label:key,value:0,total:null})), 1),
                _createElementVNode("button", {
                  type: "button",
                  disabled: saving.value || index === 0,
                  "aria-label": _unref(t)('hr.analyticsMoveUp'),
                  onClick: ($event: any) => (move(index,-1))
                }, "↑", 8, _hoisted_22),
                _createElementVNode("button", {
                  type: "button",
                  disabled: saving.value || index === _unref(draft).widgets.length-1,
                  "aria-label": _unref(t)('hr.analyticsMoveDown'),
                  onClick: ($event: any) => (move(index,1))
                }, "↓", 8, _hoisted_23)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(report.value?.metrics || {}), (metric) => {
              return (_openBlock(), _createElementBlock("label", {
                key: metric.key
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(draft).widgets) = $event)),
                  type: "checkbox",
                  value: metric.key,
                  disabled: saving.value
                }, null, 8, _hoisted_25), [
                  [_vModelCheckbox, _unref(draft).widgets]
                ]),
                _createTextVNode(_toDisplayString(metricLabel(metric)), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_unref(Button), {
              type: "button",
              variant: "default",
              disabled: saving.value,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (editing.value=false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_unref(Button), {
              type: "submit",
              disabled: saving.value || !_unref(canConfigure)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('common.save')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 40, _hoisted_17)
      ]),
      _: 1
    }, 8, ["show", "title"])
  ]))
}
}

})